import { Component } from '@angular/core';
//import { IonicPage, NavController } from 'ionic-angular';
//import { HomePage } from '../home/home';

//@IonicPage()
@Component({
  selector: 'page-pc-tabs',
  templateUrl: 'pc-tabs.html'
})
export class PcTabsPage {

  partesRoot = 'PartesPage'
  personalRoot = 'PersonalPage'
  ajustesRoot = 'AjustesPage'

  constructor(/*public navCtrl: NavController*/) {}

}



// WEBPACK FOOTER //
// ./src/pages/pc-tabs/pc-tabs.ts